import { useEffect, useState } from 'react';

/**
 * The value as of `delayMs` after it last changed. Used to hold a network
 * request (the branding preview) until the user pauses typing. The timer is
 * cleared on every change and on unmount, so an unmounted component never
 * flushes a stale value into a setState.
 */
export function useDebouncedValue<T>(value: T, delayMs: number): T {
  const [debounced, setDebounced] = useState<T>(value);
  useEffect(() => {
    const timer = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(timer);
  }, [value, delayMs]);
  return debounced;
}
